<template>
  <div>
    <a-form
      class="iotplt-nested-search-form"
      :form="form"
      @submit="handleSearch"
    >
      <a-row :gutter="24">
        <a-col :span="8" :xxl="6">
          <a-form-item>
            <a-input
              v-decorator="['iccid_or_phone_number_or_imsi', {
                normalize: this.$lodash.trim
              }]"
              placeholder="请输入ICCID或手机号或IMSI或短号"
              allow-clear
            >
              <span slot="addonAfter" @click="showBatchInputIccidsModal" class="iotplt-cursor-pointer">批量输入</span>
            </a-input>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6" v-show="expand">
          <a-form-item label="运营商种类">
            <a-select
              v-decorator="['carrier_type']"
              allow-clear
            >
              <a-select-option
                v-for="option in carrierTypeOptions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <!-- <a-col :span="8" :xxl="6" v-show="expand">
          <a-form-item label="供应商">
            <a-select
              v-decorator="['supplier']"
              allow-clear
              @focus="fetchSupplierOptions"
              :loading="loadingSupplierOptions"
            >
              <a-select-option
                v-for="option in supplierOptions"
                :key="option.ID"
                :value="option.ID"
              >
                {{ option.Name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->

        <a-col :span="8" :xxl="6" v-show="expand">
          <a-form-item label="到期时间">
            <a-select
              v-decorator="['time_end_type']"
              allow-clear
            >
              <a-select-option
                v-for="option in timeEndTypeOptions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6" v-show="expand">
          <a-form-item label="采购套餐">
            <a-input
              v-decorator="['package', {
                normalize: this.$lodash.trim
              }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6" v-show="expand">
          <a-form-item label="项目">
            <a-input
              v-decorator="['project', {
                normalize: this.$lodash.trim
              }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6" v-show="expand">
          <a-form-item label="分组">
            <a-input
              v-decorator="['group_name', {
                normalize: this.$lodash.trim
              }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6" v-show="expand">
          <a-form-item label="设备名称">
            <a-input
              v-decorator="['device_name', {
                normalize: this.$lodash.trim
              }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6" v-show="expand">
          <a-form-item label="设备序列号">
            <a-input
              v-decorator="['device_sn', {
                normalize: this.$lodash.trim
              }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
              <a-button :style="{ fontSize: '12px', lineHeight: '32px' }" @click="toggle">
                更多条件
                <a-icon :type="expand ? 'up' : 'down'" />
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <!-- 批量验证模态框 -->
    <batch-input-iccids
      v-if="isShowBatchInputIccidsModal"
      :visible.sync="isShowBatchInputIccidsModal"
      :agent-id="agentId"
      @submit="submitBatchValidate"
    />
  </div>
</template>
<script>
import {
  findCarrierTypeOptions, findEndTimeTypeOptions
} from '@/api/common_options'

import {
  findSupplierOptions
} from '@/api/oc_supplier'

export default {
  name: 'SearchAgentSimCard',
  components: {
    BatchInputIccids: () => import('@/views/oc_sim_cards/BatchInputIccids')
  },
  props: {
    agentId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      expand: false,
      carrierTypeOptions: findCarrierTypeOptions(),
      timeEndTypeOptions: findEndTimeTypeOptions(),
      supplierOptions: [],
      loadingSupplierOptions: false,
      isShowBatchInputIccidsModal: false, // 是否显示批量输入卡号模态框
      form: this.$form.createForm(this, { name: 'sim_card_search' })
    }
  },
  methods: {
    toggle() {
      this.expand = !this.expand
    },

    showBatchInputIccidsModal() {
      this.isShowBatchInputIccidsModal = true
    },

    submitBatchValidate(iccids) {
      this.form.setFieldsValue({
        iccid_or_phone_number_or_imsi: iccids
      })
    },

    // 加载供应商选项数据
    fetchSupplierOptions() {
      if (this.supplierOptions.length === 0) {
        this.loadingSupplierOptions = true
        findSupplierOptions().then(res => {
          if (res.code === 0) {
            this.supplierOptions = res.data
            this.loadingSupplierOptions = false
          }
        })
      }
    },

    handleSearch(e) {
      e.preventDefault()
      this.$emit('submit', this.form.getFieldsValue())
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>
